<script lang="ts">
export default {
  name: "AppNavigationHeader",
};
</script>

<template>
  <header class="navigation-header">
    <div id="header-left" class="navigation-header__left"></div>
    <div id="header-right" class="navigation-header__right"></div>
  </header>
</template>

<style lang="scss" scoped>
@import "index";
</style>
